import store from '../store/index'
/*reporting-service  = reporting
customer-service  = customer
analysis-service  = analysis
resource-service  = resource
sales-service  = sales
smartparty-service  = smartparty
system-service  = system
trade-service  = trade
user-service  = user
workflow-service  = workflow
customer-query-service  = customer-query
AuthCenter  = oauthep*/

export const parseUrl = (url) => {
    let obj = {
        reporting: ['report'],
        customer: ['cueManagement', 'customer', 'customerContact','customer_follow_up_parameters', 'customerFollowUpTask', 'customerInfo', 'customer_extend', 'follow_up_rule_settings', 'follow_up_target_rule_setting'],
        analysis: [],
        resource: ['standard_price', 'building', 'new', 'resource', 'config', 'resource_manage', 'resourceImport'],
        sales: ['sale','sales'],
        smartparty: ['api', 'sparty_column', 'sparty_content', 'sparty_dev_apply', 'sparty_fee', 'sparty_group', 'sparty_meeting', 'sparty_membership', 'sparty_Position', 'sparty_reports', 'sparty_Trunk', 'sparty_vote_action', 'sparty_votes', 'sparty_votes_options'],
        system: ['mgr', 'system_constants', 'system', 'file', 'image', 'short_messager_template', 'short_messager_type', 'area','dataDictionary'],
        trade: ['relet','orderV2','asop', 'contract', 'cost_item', 'item_use', 'deposit', 'model', 'dueChargesBill', 'lateChargeReduce', 'leaseContractEnter', 'leaseContractOutgoing', 'leaseContractTermination', 'leaseContractTerminationV2', 'order', 'press', 'project_config', 'ReductionOfRent', 'tax_rate', 'visiting', 'visitingModel'],
        user: ['agency', 'department', 'group', 'menu', 'operation', 'resource_group', 'role', 'rule', 'operation', 'uaa_user'],
        workflow: ['actReProcdef', 'commonProcess', 'process'],
        customerQuery: ['query', 'security_v2', 'customer', 'index', 'print', 'security'],
        oauthep: [],
        property: ['property', 'ydcloudPropertyMaterial', 'ydcloudPropertyRepair'],
    }
    if (url.indexOf('admin') == -1) {
        return url;
    }
    let first = url.split('admin')[1].split('/')[1];
    // 客户模块
    if (first == 'customer' && url.indexOf('contract') != -1) {
        return url.replace('admin', 'customerQuery')
    } else if (first == 'customer') {
        return url.replace('admin', 'customer')
    }
    for (let o in obj) {
        if (obj[o].includes(first)) {
            return url.replace('admin', o);
        }
    }
    return url;
}

/**

 * 数字格式转换成千分位
 * @param{Object}num
 */
export function commafy(num) {
    if ((num + "").trim() == "") {
        return "";
    }
    if (isNaN(num)) {
        return "";
    }
    num = num + "";
    if (/^.*\..*$/.test(num)) {
        let pointIndex = num.lastIndexOf(".");
        let intPart = num.substring(0, pointIndex);
        let pointPart = num.substring(pointIndex + 1, num.length);
        intPart = intPart + "";
        let re = /(-?\d+)(\d{3})/
        while (re.test(intPart)) {
            intPart = intPart.replace(re, "$1,$2")
        }
        num = intPart + "." + pointPart;
    } else {
        num = num + "";
        let re = /(-?\d+)(\d{3})/
        while (re.test(num)) {
            num = num.replace(re, "$1,$2")
        }
    }
    return num;
}

//获取窗口的可视区域的高度
export function getClientHeight()
{
    let winHeight
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    return winHeight
}
